import React from "react";
import { useUpdateFaqCategory } from "../../../../../../api/inquiries/faq/use-faq-category";
import Button from "../../../../../../components/ui/Button/Button";
import Modal from "../../../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../../../utils/Form/ui/FieldBox";

const EditFAQ = ({ defaultValue }) => {
  const [catName, setCatName] = React.useState(defaultValue?.name);
  const [catStatus, setCatStatus] = React.useState(defaultValue?.status);
  const { mutate: updateFaqCategory } = useUpdateFaqCategory();
  const [triggerClose, setTriggerClose] = React.useState(false);

  React.useEffect(() => {
    if (triggerClose === true) {
      setTriggerClose(false);
    }
  }, [triggerClose]);
  const onChangeCatName = (e) => {
    setCatName(e.target.value);
  };

  const onChangeStatus = (e) => {
    setCatStatus(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      await updateFaqCategory({
        name: catName,
        status: catStatus,
        id: defaultValue?.id,
      });
      setTriggerClose(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      maxWidth="max-w-[35rem]"
      title="FAQ 분류 유형 추가"
      rightTittle={
        <div className="flex gap-2 justify-end items-center">
          <Modal
            description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
            onSubmit={() => setTriggerClose(true)}
          >
            <Button width="w-20" text="입력취소" />
          </Modal>
          <Button
            onClick={handleSubmit}
            width="w-20"
            text="저장완료"
            primary
            isDisabled={
              defaultValue?.name ? defaultValue?.name === "" : catName === ""
            }
          />
        </div>
      }
      triggerClose={triggerClose}
      hasCancel={false}
      hasSubmit={false}
      description={
        <div>
          <FieldBox
            unSplittedWidth="w-[40%]"
            contentWidth="w-[60%]"
            label="분류 유형 명"
          >
            <input
              placeholder="분류 유형 명을 입력하세요"
              type="text"
              className="border outline-none border-border-grey p-1.5 rounded-[4px] w-full bg-white"
              value={catName}
              onChange={onChangeCatName}
            />
          </FieldBox>

          <FieldBox
            unSplittedWidth="w-[40%]"
            contentWidth="w-[60%]"
            label="공개여부"
            isLast
          >
            <div className="flex gap-8 items-center">
              <div className="flex gap-1 items-center">
                <input
                  name="status"
                  type="radio"
                  value="ON"
                  id="ON"
                  className="flex-none accent-primary-black"
                  checked={catStatus === "ON"}
                  onChange={onChangeStatus}
                />
                <label htmlFor="ON">공개</label>
              </div>

              <div className="flex gap-1 items-center">
                <input
                  name="status"
                  type="radio"
                  value="OFF"
                  id="OFF"
                  className="flex-none accent-primary-black"
                  checked={catStatus === "OFF"}
                  onChange={onChangeStatus}
                />
                <label htmlFor="OFF">비공개</label>
              </div>
            </div>
          </FieldBox>
        </div>
      }
    >
      <Button
        type="button"
        borderColor="border border-[#cccccc]"
        paddingButton="p-1"
        margin="mr-0"
        text="변경"
        width="w-12"
      />
    </Modal>
  );
};

export default EditFAQ;
